import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { StationService } from 'src/app/_services/station.service';
import { ChargeBoxService } from '../../../_services/chargebox/chargebox.service';
import 'rxjs/add/observable/interval';
import { Subscription } from 'rxjs';
import { ConnectorStatus, ConnetorColorCodes } from 'src/app/modules/ocpp/enums/connector.enum';
import { MenuRouteID } from '../../header/menu-item/nav-item';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from 'src/app/_service/message-service';

@Component({
  selector: 'telio-station-details',
  templateUrl: './station-details.component.html',
  styleUrls: ['./station-details.component.scss']
})
export class StationDetailsComponent implements OnInit, OnDestroy {

  lat = 22.87021236203436;
  lng = 78.45861722464625;
  /* OCPP */
  stations: any = [];
  stationdetail: any = {};
  bootDetail: any = {};
  stationId: any;
  ActiveStatus;
  noOfConnectors;
  ports = [];
  portTypes = '';
  isDeviceConnected = false;
  statusSubs: Subscription = new Subscription;
  vendorID;
  routedComponent: string;
  tabIndex = 0;
  cpoId;
  tabsRouteID = MenuRouteID.TABS;
  availableTabs = [
    { id: MenuRouteID.TABS.DEVICE_SPEC, enable: false },
    { id: MenuRouteID.TABS.DEVICE_MGMT, enable: false },
    { id: MenuRouteID.TABS.DEVICE_CONFIG, enable: false },
    { id: MenuRouteID.TABS.DEVICE_TRANS, enable: false },
    { id: MenuRouteID.TABS.DEVICE_LOGS, enable: false },
    { id: MenuRouteID.TABS.AMENITIES, enable: false },
    { id: MenuRouteID.TABS.STATION_IMAGES, enable: false }
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private stationService: StationService,
    private chargeBoxService: ChargeBoxService,
    readonly userInfoService: UserInfoService,
    readonly translate: TranslateService,
    readonly toastr: SnackbarService
  ) {
    this.stationId = JSON.parse(this.router.getCurrentNavigation().extras.queryParams.stationid);
  }

  ngOnInit() {
    this.availableTabs = this.userInfoService.getPermittedTabs(+this.route.snapshot.paramMap.get('routeID'), this.availableTabs);
    let tabExists = this.availableTabs.filter(res => res.enable);
    !tabExists || tabExists.length == 0 ? this.toastr.info(this.translate.instant('unAuthorized')) : '';
    this.route.queryParams.subscribe(params => {
      this.stationId = JSON.parse(params.stationid);
      this.routedComponent = params['routedName'];
      if (this.routedComponent == 'deviceAmenities')
        this.tabIndex = 1;
      else if (this.routedComponent == 'devicePhotos')
        this.tabIndex = 2;
    });
    this.getstationlistbyid(this.stationId);
    this.getBootNotificationDetails(this.stationId);
  }

  getstationlistbyid(id) {
    this.stationService.getstationlistbyid(id).subscribe(
      (data: any) => {
        Object.keys(data).map(x => {
          if (data[x] !== false) {
            (!data[x] || data[x] == '') ? data[x] = 'NA' : null;
          }
        });
        this.stationdetail = data;
        this.vendorID = data.vendorId;
        this.cpoId = this.stationdetail.vendorId
        this.stationdetail['noOfConnectors'] = this.stationdetail.connectors[0].totalConnectors;
        this.stationdetail['portTypes'] = this.stationdetail.connectors[0].connectors.map(res => res.portType);
        this.stationdetail['location'] = (data.country != 'NA' && data.city != 'NA') ? data.country + ', ' + data.city : data.country || data.city || 'NA';
        this.stationdetail['connectorsList'] = this.stationdetail.connectors[0].connectors;
        !!this.stationdetail.connectors[0] && this.stationdetail.connectors[0].connectors.map(res => {
          res.chargingStatus = ConnectorStatus.UNAVAILABLE;
        });
        this.chargeBoxService.isChargeBoxConnected(id).subscribe((data: any) => {
          if (data.is_connected) {
            this.isDeviceConnected = data ? data.is_connected : false;
            this.statusSubs = this.stationService.getStatusNotification(id).subscribe(response => {
              if (response.length > 0) {
                if (this.stationdetail && this.stationdetail.connectors && this.stationdetail.connectors.length > 0 && this.stationdetail.connectors[0].connectors) {
                  this.stationdetail.connectors[0].connectors.forEach((element, index: any) => {
                    let contr = response.filter(x => x.connectorId == element.connectorId);
                    this.stationdetail.connectors[0].connectors[index].chargingStatus = contr.length > 0 ? contr[0].status : ConnectorStatus.UNAVAILABLE;
                  });
                  let connectors = this.stationdetail.connectors[0].connectors;
                  let available = connectors.filter(x => x.chargingStatus == "AVAILABLE");
                  this.stationdetail['actualVendor'] = this.stationdetail.vendorId ? this.stationdetail.vendorId : '';
                  if (available.length == connectors.length) {
                    this.stationdetail['connectorsStatus'] = ConnectorStatus.AVAILABLE;
                    this.stationdetail['connectorsStatusColor'] = ConnetorColorCodes.GREEN;
                  }
                  else if (available.length > 0) {
                    this.stationdetail['connectorsStatus'] = ConnectorStatus.PARTIALLY;
                    this.stationdetail['connectorsStatusColor'] = ConnetorColorCodes.ORANGE;
                  }
                  else {
                    let charging = connectors.filter(x => x.chargingStatus == "CHARGING");
                    if (charging.length == connectors.length) {
                      this.stationdetail['connectorsStatus'] = ConnectorStatus.BUSY;
                      this.stationdetail['connectorsStatusColor'] = ConnetorColorCodes.RED;
                    }
                    else if (charging.length == 0) {
                      this.stationdetail['connectorsStatus'] = ConnectorStatus.UNAVAILABLE;
                      this.stationdetail['connectorsStatusColor'] = ConnetorColorCodes.UNAVBLE;
                    }
                  }
                }
              } else {
                !!this.stationdetail.connectors[0] && this.stationdetail.connectors[0].connectors.map(res => {
                  res.chargingStatus = ConnectorStatus.UNAVAILABLE;
                });
                this.stationdetail['connectorsStatus'] = ConnectorStatus.UNAVAILABLE;
                this.stationdetail['connectorsStatusColor'] = ConnetorColorCodes.UNAVBLE;
              }
            }, err => {
              !!this.stationdetail.connectors[0] && this.stationdetail.connectors[0].connectors.map(res => {
                res.chargingStatus = ConnectorStatus.UNAVAILABLE;
              });
              this.stationdetail['connectorsStatus'] = ConnectorStatus.UNAVAILABLE;
              this.stationdetail['connectorsStatusColor'] = ConnetorColorCodes.UNAVBLE;
            })
          } else {
            this.stationdetail['connectorsStatus'] = ConnectorStatus.UNAVAILABLE;
            this.stationdetail['connectorsStatusColor'] = ConnetorColorCodes.UNAVBLE;
            !!this.stationdetail.connectors[0] && this.stationdetail.connectors[0].connectors.map(res => {
              res.chargingStatus = ConnectorStatus.UNAVAILABLE;
            });
          }
        }, err => {
          this.stationdetail['connectorsStatus'] = 'NA';
          !!this.stationdetail.connectors[0] && this.stationdetail.connectors[0].connectors.map(res => {
            res.chargingStatus = ConnectorStatus.UNAVAILABLE;
          });
        });
      },
      error => {
        this.stationdetail = [];
        this.chargeBoxService.isChargeBoxConnected(this.stationId).subscribe((data: any) => {
          this.isDeviceConnected = data ? data.is_connected : false;
        });
      }
    );
  }

  getBootNotificationDetails(chargeBoxId) {
    this.stationService.getBootNotificationDetails(chargeBoxId).subscribe(
      (data: any) => {
        let empty = 'NA';
        if (!!data) {
          Object.keys(data).map(x => {
            if (data[x] !== false) {
              (!data[x] || data[x] == '') ? data[x] = 'NA' : null;
            }
          });

          this.bootDetail['vendorName'] = data.chargePointVendor ? data.chargePointVendor : empty;
          this.bootDetail['firmwareVersion'] = data.firmwareVersion ? data.firmwareVersion : empty;
          this.bootDetail['model'] = data.chargePointModel ? data.chargePointModel : empty;
          if (data.chargePointSerialNumber) {
            this.bootDetail['serial'] = data.chargePointSerialNumber
          }
          else {
            this.bootDetail['serial'] = data.chargeboxSerialNumber ? data.chargeboxSerialNumber : empty;
          }
        } else {
          this.getBootNotificationDetailsNA();
        }
      }, err => {
        this.getBootNotificationDetailsNA();
      })
  }

  getBootNotificationDetailsNA() {
    let empty = 'NA';
    this.bootDetail['vendorName'] = empty;
    this.bootDetail['firmwareVersion'] = empty;
    this.bootDetail['model'] = empty;
    this.bootDetail['serial'] = empty;
  }

  ngOnDestroy() {
    this.statusSubs.unsubscribe();
  }

  back() {
    this.stationId ? this.navigateTo() : this.router.navigate(['/dashboard/home', { routeID: MenuRouteID.HOME }]);
  }

  navigateTo() {
    if (this.routedComponent === 'deviceAmenities' || this.routedComponent === 'deviceSpec' || this.routedComponent == 'devicePhotos') {
      this.router.navigate(['/dashboard/stations/details', { routeID: MenuRouteID.STATIONS }], { queryParams: { "stationid": JSON.stringify(this.stationId) } })
    }
    else if (this.routedComponent === 'vendorStations') {
      this.router.navigate(['/dashboard/operators/details', { routeID: MenuRouteID.OPERATORS }], { queryParams: { "vendorid": JSON.stringify(this.cpoId), index: '1' } })
    } else if (this.routedComponent === 'chargingTransactions') {
      this.router.navigate(['/dashboard/charging-transactions', { routeID: MenuRouteID.CHARGING_TRANSACTION }]);
    } else if (this.routedComponent === 'map') {
      this.router.navigate(['/dashboard/home', { routeID: MenuRouteID.HOME }]);
    }
    else if (this.routedComponent === 'alertnnotification') {
      this.router.navigate(['/dashboard/alerts', { routeID: MenuRouteID.ALERTS }]);
    }
    else {
      this.router.navigate(['/dashboard/stations', { routeID: MenuRouteID.STATIONS }], { queryParams: { "state": true } });
    }

  }

}
